import Media from './media';
import Richtext from './richtext';

export default class AlertMessage {
  backgroundColor: string;
  icon?: Media;
  message?: Richtext;
  closeIcon?: Media;

  constructor(props: any) {
    this.backgroundColor = props.backgroundColor;
    this.icon = props.icon ? new Media(props.icon) : undefined;
    this.closeIcon = props.closeIcon ? new Media(props.closeIcon) : undefined;
    this.message = props.message ? new Richtext(props.message) : undefined;
  }
}
